import { combineReducers } from "redux";
import { errorReducer } from "./errorReducer";
import successReducer from "./successReducer";
import applicationsReducer from "./applicationsReducer";
import admissionsReducer from "./admissionsReducer";
import paymentsReducer from "./paymentsReducer";
import documentRequestReducer from "./documentRequestReducer";
import admissionOffersReducer from "./admissionOffersReducer";
import studentsReducer from "./studentsReducer";
import examinationCentersReducer from "./examinationCentersReducer";
import applicationResponsesReducer from "./applicationResponsesReducer";
import downloadablesReducer from "./downloadablesReducer";
import invoicesReducer from "./invoicesReducer";
import subjectsReducer from "./subjectsReducer";
import studentFeedbackReducer from "./studentFeedbackReducer";
import assessmentsReducer from "./assessmentsReducer";
import disciplinaryRecordsReducer from "./disciplinaryRecordsReducer";
import exeatsReducer from "./exeatsReducer";
import dashboardReducer from "./dashboardReducer";
import traitsReducer from "./traitsReducer";

const rootReducer = combineReducers({
    success: successReducer,
    errors: errorReducer,
    applications: applicationsReducer,
    admissions: admissionsReducer,
    payments: paymentsReducer,
    documentRequests: documentRequestReducer,
    admissionOffers: admissionOffersReducer,
    students: studentsReducer,
    examinationCenters: examinationCentersReducer,
    applicationResponses: applicationResponsesReducer,
    downloadables: downloadablesReducer,
    invoices: invoicesReducer,
    subjects: subjectsReducer,
    feedback: studentFeedbackReducer,
    assessments: assessmentsReducer,
    disciplinaryRecords: disciplinaryRecordsReducer,
    exeats: exeatsReducer,
    dashboard: dashboardReducer,
    traits: traitsReducer,
});

export default rootReducer;